import __ from "../admin-utils/LanguageHelper"
import logo from "./logo"
import {Box} from "@material-ui/core"
import React from "react"
import {useSelector} from "react-redux"
import {NotificationItem} from "../components/notificationItem"

const baseDomain = 'https://maintenance-api.appsbackend.xyz'
const baseUrl = baseDomain + '/v1'
const authables = []
const currency = __('ريال', 'SAR')

export const managementTitle = __('إدارة صيانة الاتصالات', 'Communications Maintenance Management')

// Form Options
export const formOptions = {
  keepData: false,
  clearInputs: false,
  maxUpload: 5000
}

// Table Options
export const tableOptions = {
  autoIDColumn: false,
  autoSerialNumber: true,
}

// PDF Options
export const pdfOptions = {
  allowPrint: false,
  logo
}

// Global Options
export const globalOptions = {
  enableAccessGuard: true,
}

export const statusOptions = [
  {id: 'sent', name: __('جار المعالجة', 'Processing')},
  {id: 'rejected', name: __('الطلب مرفوض', 'Order Rejected')},
  {id: 'approved', name: __('قيد المعاينة', 'Under Inspection')},
  {id: 'wip', name: __('جاري التنفيذ', 'WIP')},
  {id: 'waiting_approval', name: __('جاري الاعتماد', 'Waiting Approval')},
  {id: 'created', name: __('تم الانشاء', 'Created')},
  {id: 'rejected', name: __('الطلب مرفوض', 'Order Rejected')},
  {id: 'cancelled', name: __('تم الالغاء', 'Cancelled')},
  {id: 'approved', name: __('تم الاعتماد', 'Approved')},
  {id: 'hold', name: __('الطلب معلق', 'Hold')},
  {id: 'complete', name: __('الطلب مكتمل', 'Completed')},
  {id: 'quotation', name: __('تم ارسال عرض سعر', 'Quotation Sent')},
]

export const statusColors = [
  {
    value: 'sent',
    compare: '=',
    color: 'yellow[700]',
  },
  {
    value: 'created',
    compare: '=',
    color: 'yellow[700]',
  }, {
    value: 'cancelled',
    compare: '=',
    color: 'red[500]',
  }, {
    value: 'rejected',
    compare: '=',
    color: 'red[500]',
  }, {
    value: 'approved',
    compare: '=',
    color: 'green[500]',
  }, {
    value: 'hold',
    compare: '=',
    color: 'orange[500]',
  }, {
    value: 'complete',
    compare: '=',
    color: 'green[800]',
  }, {
    value: 'wip',
    compare: '=',
    color: 'orange[500]',
  },  {
    value: 'waiting_approval',
    compare: '=',
    color: 'orange[600]',
  },  {
    value: 'quotation',
    compare: '=',
    color: 'green[800]',
  }
]

export const Notifications = () => {
  const {notifications} = useSelector((state) => state)
  const locationPath = window.location.pathname

  return (
    <Box maxWidth={400}>
      {notifications?.notifications.map(notification => (
        <>
          {notification.href === locationPath && (
            <NotificationItem notification={notification} />
          )}
        </>
      ))}
    </Box>
  )
}


export
{
  baseUrl,
  baseDomain,
  authables,
  currency,
}
